module.exports = __webpack_public_path__ + "static/media/one.a28ca903.svg";